import { type RefObject, useState, useLayoutEffect } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import requireValue from 'utils/requireValue';

const useSize = (target: RefObject<HTMLElement>) => {
  const [size, setSize] = useState<DOMRectReadOnly>();

  useLayoutEffect(() => {
    setSize(requireValue(target.current, 'getBoundingClientRect').getBoundingClientRect());
  }, [target]);

  useResizeObserver(target, (entry) => setSize(entry.contentRect));
  return size;
};

export default useSize;
